import { render, staticRenderFns } from "./DailyCustomerConsentAggregateConsents.vue?vue&type=template&id=f50cc316&scoped=true&"
import script from "./DailyCustomerConsentAggregateConsents.vue?vue&type=script&lang=ts&"
export * from "./DailyCustomerConsentAggregateConsents.vue?vue&type=script&lang=ts&"
import style0 from "./DailyCustomerConsentAggregateConsents.vue?vue&type=style&index=0&id=f50cc316&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50cc316",
  null
  
)

export default component.exports